import { createSelector } from 'reselect'

import viewTypes from 'helpers/enums/viewTypes'
import modalTypes from 'helpers/enums/modalTypes'

const currentViewSelector = state => state.ui.currentView
const modalSelector = state => state.modal

const cancelSlideSelector = createSelector(
	[ currentViewSelector, modalSelector ],
	(currentView, modals) => {
		let qlModalActivity = false

		if (modals.length) {
			qlModalActivity =
				modals[0].modalName === modalTypes.QUICK_LAUNCH_COLLABORATE_CREATE
		}

		const quickLaunchViews = [
			viewTypes.QUICK_LAUNCH_OEQ_ACTIVITY_CREATION,
			viewTypes.QUICK_LAUNCH_DRAW_IT_ACTIVITY_CREATION,
			viewTypes.QUICK_LAUNCH_FIELD_TRIP_ACTIVITY_CREATION,
			viewTypes.QUICK_LAUNCH_TIMER_ACTIVITY_CREATION,
		]

		return quickLaunchViews.includes(currentView) || qlModalActivity
	}
)

export default cancelSlideSelector
